<template>
    <div v-for="(balise, index) in balises" :key="balise.id" class="balise-row-wrapper"
        :draggable="canReorder && !isSavingOrder" @dragstart="$emit('dragstart', $event, balise.id)"
        @dragover="$emit('dragover', $event, balise.id)" @dragleave="$emit('dragleave', $event, balise.id)"
        @drop="$emit('drop', $event, balise.id)" @dragend="$emit('dragend')">
        <BaliseRowDisplay :index="index" :balise="balise" :groups="groups" :dragEnabled="canReorder && !isSavingOrder"
            :isDragging="draggedBaliseId === balise.id" :isDropTarget="dropTargetBaliseId === balise.id"
            @save="$emit('save', $event)" @changeIcon="$emit('changeIcon', $event)" />
    </div>
</template>

<script>
import BaliseRowDisplay from '../components/BaliseRowDisplay.vue'

export default {
    name: 'BalisesListRow',
    components: {
        BaliseRowDisplay
    },
    props: {
        balises: {
            type: Array,
            default: () => []
        },
        groups: {
            type: Array,
            default: () => []
        },
        canReorder: {
            type: Boolean,
            default: false
        },
        isSavingOrder: {
            type: Boolean,
            default: false
        },
        draggedBaliseId: {
            type: [Number, String, null],
            default: null
        },
        dropTargetBaliseId: {
            type: [Number, String, null],
            default: null
        }
    },
    emits: [
        'save',
        'changeIcon',
        'dragstart',
        'dragover',
        'dragleave',
        'drop',
        'dragend'
    ]
}
</script>

<style scoped>
.balise-row-wrapper[draggable="true"] {
    cursor: move;
}
</style>